import CustomModal from '@/components/shared/CustomModal/CustomModal'
import { VALUES_BY_TYPE } from '@/constants/checkMappings'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

const MAP_FIELDNAMES = [{
    key: 'productionType', 
    label: 'Product',
}, {
    key: 'interestTypeProd',
    label: 'Interest Type',
}, {
    key: 'interestTypeDeduct',
    label: 'Adjustment',
}]

export const SOURCE_CHECKS = 'checks'
export const SOURCE_REPORTS = 'reports'

const MappingModal = ({ showModal, showHideModal, checkMappings, onFinishMapping, source = SOURCE_REPORTS }) => {
    
    const [editedFields, setEditedFields] = useState({})
    
    const onButtonClick = () => {
        if ((source === SOURCE_REPORTS &&
            checkMappings.length === Object.keys(editedFields).length) || source === SOURCE_CHECKS) {
            onFinishMapping(editedFields)
            showHideModal(!showModal)
        } else
            toast.error('There are still fields to be mapped.' +
                `${source === SOURCE_REPORTS && ' Report can\'t be generated'}`)
    }
    
    const addEditedField = (editedField, newCleanFieldValue) => {
        editedField.cleanField = newCleanFieldValue
        setEditedFields({ ...editedFields, [editedField.hash]: { ...editedField } })
    }
    
    useEffect(() => {
        if (showModal) setEditedFields({})
    }, [showModal])
    
    return (
        <CustomModal
            open={showModal}
            modalHandler={() => showHideModal(!showModal)}
            center>
            
            <div className="modal-header flex-col pb-2">
                <h2 className="modal-title mb-2">
                    Check Mappings
                </h2>
                <span className="text-muted">
                    {source === SOURCE_REPORTS && 'Define the mappings to generate the report'}
                    {source === SOURCE_CHECKS && 'Define the mappings for this check'}
                </span>
            </div>
            
            <div className="modal-body p-0" style={{ maxHeight: 'calc(70vh - 175px)', overflow: 'auto' }}>
                <table className="table table-auto table-pin-rows">
                    
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Unmapped Value</th>
                            <th>Mapped Value</th>
                        </tr>
                    </thead>
                    
                    <tbody>
                        {checkMappings?.map(it => (
                            <tr key={it.hash}>
                                <td>{MAP_FIELDNAMES.find(fn => fn.key === it.filter).label}</td>
                                <td>{it.dirtyField}</td>
                                <td>
                                    <select
                                        value={editedFields[it.hash]?.cleanField || it.cleanField || ''}
                                        className="select max-w-sm"
                                        onChange={evt => addEditedField({ ...it }, evt.target.value)}>
                                        {!editedFields[it.hash]?.cleanField && !it.cleanField && (
                                            <option value="" />
                                        )}
                                        {VALUES_BY_TYPE[it.filter].map((vt, i) => (
                                            <option key={i} value={vt}>
                                                {vt}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                
                </table>
            </div>
            
            <div className="modal-footer flex justify-end">
                
                <button
                    className="mr-3 btn btn-primary btn-outline"
                    onClick={() => showHideModal(!showModal)}>
                    Cancel
                </button>
                <button
                    className={'btn btn-primary'}
                    disabled={
                        (source === SOURCE_REPORTS &&
                            checkMappings.length !== Object.keys(editedFields).length) ||
                        (source === SOURCE_CHECKS && false)
                    }
                    onClick={onButtonClick}>
                    Map Fields{source === SOURCE_REPORTS && ' and Create Report'}
                </button>
            </div>
        
        </CustomModal>
    )
}

export default MappingModal
